import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-[var(--ds-radius-pill)] border px-[var(--ds-space-2-5)] py-[var(--ds-space-half)] text-xs font-semibold tracking-[var(--ds-type-control-tracking)]",
  {
    variants: {
      variant: {
        default:
          "border-primary/20 bg-primary text-primary-foreground",
        secondary:
          "border-border bg-secondary text-secondary-foreground",
        destructive:
          "border-destructive/25 bg-destructive text-destructive-foreground",
        success:
          "border-success/25 bg-success text-success-foreground",
        warning:
          "border-warning/30 bg-warning text-warning-foreground",
        info:
          "border-info/25 bg-info text-info-foreground",
        outline: "border-border bg-card/70 text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => {
  return (
    <div ref={ref} data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />
  );
});
Badge.displayName = "Badge";

export { Badge };
